/**
 * Registers the `chat` i18n namespace (strings for `BasicChatPanel`, default `translationNamespace`).
 *
 * @param {(ns: string, loaders: Record<string, () => Promise<unknown>>) => void} registerNamespace
 */
export function registerChatI18n(registerNamespace) {
  registerNamespace('chat', {
    en: () => import('../../locales/en.json'),
    es: () => import('../../locales/es.json'),
  });
}
